import { Avatar, Box, Button, Card, CardActions, CardContent, CardHeader, Chip, Dialog, DialogActions, DialogTitle, Divider, IconButton, SxProps, Theme, ToggleButton, ToggleButtonGroup, Tooltip, TooltipProps, Typography, styled, tooltipClasses } from "@mui/material";
import { CardActionStyles } from "../Feed/FeedStyle";
import PostEmbbding from "../Shared/PostEmbbeding";
import { capitalizeFirstLetter, recognizePlatform } from "../../utils/postUtils";
interface props{
    url:string
}

const PostCampaignCard = ({url}:props)=>{   
    const styles = CardActionStyles;
    return (
        <>
        <Card
            raised
            elevation={24}
            sx={() => ({
                ...styles.outerCard,
            })
            }>
            <Box sx={styles.cardHeader}>
                <Box sx={styles.likeSection}>

                    <Box sx={styles.platformTag}>
                        <Typography sx={{
                            fontSize: { xs: "10px", sm: '10px', md: "12px" },
                        }} fontWeight={'bold'} variant="subtitle2">{capitalizeFirstLetter(recognizePlatform(url))}</Typography>
                    </Box>
                </Box>
            </Box>
            
            <CardContent sx={styles.ResponsiveHeight}>

                <Box sx={styles.EmbededPost}>

                    <Box className="custom-scrollbar" sx={styles.ResponsiveHeight}>
                        <PostEmbbding key={url} url={url} />
                    </Box>
                </Box>
            </CardContent>
        </Card >

    </>

    );
}

export default PostCampaignCard